/**
 * AuditCommunityNotFound Component
 *
 * Displays a not found state when the requested community cannot be found.
 */

import { Card, Container, Heading, Section, Text } from '@soteria/design-system-ve';

import * as styles from '../AuditSessionDetailPage.css';

export function AuditCommunityNotFound() {
  return (
    <Container className={styles.container}>
      <Section spacing="large">
        <Card className={styles.errorCard}>
          <Section spacing="medium">
            <Heading level="h2">Community Not Found</Heading>
            <Text>The requested community could not be found.</Text>
          </Section>
        </Card>
      </Section>
    </Container>
  );
}
